import { Capacitor } from "@capacitor/core";

export type InstallPromptChoice = { outcome: "accepted" | "dismissed"; platform: string };

export interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<InstallPromptChoice>;
}

export function isStandaloneDisplayMode() {
  if (typeof window === "undefined") return false;
  if (Capacitor.isNativePlatform()) return true;
  const iosStandalone = "standalone" in window.navigator && Boolean((window.navigator as Navigator & { standalone?: boolean }).standalone);
  const displayModeStandalone = typeof window.matchMedia === "function" && window.matchMedia("(display-mode: standalone)").matches;
  return iosStandalone || displayModeStandalone;
}

export function getPasswordResetRedirectUrl(origin: string, isNative = Capacitor.isNativePlatform()) {
  return isNative ? "https://crm.jarasna.com/reset-password" : `${origin}/reset-password`;
}

export function isIosDevice(
  userAgent = typeof navigator === "undefined" ? "" : navigator.userAgent,
  platform = typeof navigator === "undefined" ? "" : navigator.platform,
  maxTouchPoints = typeof navigator === "undefined" ? 0 : navigator.maxTouchPoints,
) {
  const classicIos = /iPad|iPhone|iPod/i.test(userAgent);
  const desktopModeIpad = platform === "MacIntel" && maxTouchPoints > 1;
  return classicIos || desktopModeIpad;
}

export function registerServiceWorker() {
  if (!import.meta.env.PROD || !("serviceWorker" in navigator)) return;
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js", { scope: "/" });
  }, { once: true });
}
